export default class Constant {
    static NO_DATA_REASONS = [{
      label: '断电',
      value: 1
    }, {
      label: '例行运维',
      value: 2
    }, {
      label: '不可抗力',
      value: 4
    }, {
      label: '仪器故障',
      value: 8
    }, {
      label: '正常缺失',
      value: 16
    }]

    static NO_DATA_REASON_MAP = Constant.NO_DATA_REASONS.reduce((map, noDataReason) => {
      map[noDataReason.value] = noDataReason
      return map
    }, {})

    static DAS_FLAG_MAP = [
      ['P', '停电'],
      ['C', '校准'],
      ['M', '维护'],
      ['B', '故障'],
      ['L', '超量程下限'],
      ['H', '超量程上限'],
      ['D', '缺失']
    ].reduce((map, [flag, desc]) => {
      map[flag] = `${desc}有效`
      map[flag.toLocaleLowerCase()] = `${desc}无效`
      return map
    }, {
      N: '正常'
    })
}



// WEBPACK FOOTER //
// ./src/model/Constant.js